import React from 'react';
import { Space, Typography } from 'antd';

/** Invoice number with the bill narration or line description underneath. */
export const InvoiceNumberWithNarration: React.FC<{
  number?: string | null;
  narration?: string | null;
  extra?: React.ReactNode;
}> = ({ number, narration, extra }) => {
  const note = (narration || '').trim();
  return (
    <div>
      <Space size={4} wrap>
        <span>{number || '—'}</span>
        {extra}
      </Space>
      {note ? (
        <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12, whiteSpace: 'normal' }}>
          {note}
        </Typography.Text>
      ) : null}
    </div>
  );
};
